
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoPo06DtPendingCNforCnrtvGrid extends Serenity.EntityGrid<PoPo06DtPendingCNforCnrtvRow, any> {
        protected getColumnsKey() { return PoPo06DtPendingCNforCnrtvColumns.columnsKey; }
        protected getDialogType() { return PoPo06DtPendingCNforCnrtvDialog; }
        protected getIdProperty() { return PoPo06DtPendingCNforCnrtvRow.idProperty; }
        protected getInsertPermission() { return PoPo06DtPendingCNforCnrtvRow.insertPermission; }
        protected getLocalTextPrefix() { return PoPo06DtPendingCNforCnrtvRow.localTextPrefix; }
        protected getService() { return PoPo06DtPendingCNforCnrtvService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}